import { CiAsyncValue } from '../../../../../ui/icons-custom/IconsCustom.tsx';
import { CustomWarningsRule } from '../../../../rules/repository/custom-warnings/CustomWarnings.rule.ts';
import { RequiredRule } from '../../../../rules/repository/required/Required.rule.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { InputCommonTranslationSchema } from '../../translations/InputCommonTranslationSchema.ts';
import { getAsyncSelectOutputReferences } from '../async-select/getAsyncSelectOutputReferences.ts';
import { hydrateAsyncWidget } from '../async-select/utils/hydrateAsyncWidget.ts';
import {
  AsyncValueConfigComponent,
  AsyncValueConfigSchema,
} from './AsyncValueConfigComponent.tsx';
import { AsyncValueWidgetComponent } from './AsyncValueWidgetComponent.tsx';
import { AsyncValueWidgetPreview } from './AsyncValueWidgetPreview.tsx';
import { getAsyncValueWidgetReference } from './getAsycValueWidgetReference.ts';
import { type IAsyncValueWidget } from './IAsyncValueWidget.ts';
import { createAsyncValueFormSchema } from './schema/createAsyncValueFormSchema.ts';

export const asyncValueWidgetObjectName = (code: string) => `${code}@object`;

export const AsyncValueWidgetType: IWidgetType<IAsyncValueWidget> = {
  type: WidgetType.AsyncValue,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Advanced,
  name: 'Campo valore da servizio',
  icon: <CiAsyncValue />,
  getReference: getAsyncValueWidgetReference,
  getSiblingReferences: getAsyncSelectOutputReferences,
  hasValue: true,
  formComponent: AsyncValueWidgetComponent,
  createFormSchema: createAsyncValueFormSchema,
  previewComponent: AsyncValueWidgetPreview,
  configValidator: AsyncValueConfigSchema,
  configComponent: AsyncValueConfigComponent,
  translationSchema: InputCommonTranslationSchema,
  rules: [RequiredRule, CustomWarningsRule],
  /**
   * Per i widget asyncValue nell'hydrate ritorno, come valore
   * non il value del widget, ma la label mostrata all'utente,
   * così da poter valorizzare correttamente il pdf.
   */
  hydrate: hydrateAsyncWidget,
  aliases: ['async', 'servizio esterno'],
};
